var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { getItemValue } from './utils';
// tslint:enable:max-line-length
/**
 * @hidden
 */
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) { return _this.props.onClick(_this.props.index, e); };
        return _this;
    }
    ListItem.prototype.render = function () {
        var selected = this.props.selected;
        var renderer = this.props.render;
        var item = (React.createElement("li", { id: this.props.id, role: "option", "aria-selected": selected, className: classNames('k-item', {
                'k-state-selected': selected,
                'k-state-focused': this.props.focused
            }), onClick: this.handleClick }, getItemValue(this.props.dataItem, this.props.textField).toString()));
        return renderer !== undefined ? renderer.call(undefined, item, this.props) : item;
    };
    return ListItem;
}(React.Component));
export default ListItem;
//# sourceMappingURL=ListItem.js.map